import { defineStore } from 'pinia'
import { ref } from 'vue'
import { i18n } from '@/i18n'
import { DEFAULT_LOCALE, normalizeLocale } from '@/i18n/locales'
import type { SupportedLocale } from '@/types/i18n'

const STORAGE_KEY = 'locale'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<SupportedLocale>(DEFAULT_LOCALE)

  const applyLocale = (next: SupportedLocale): void => {
    locale.value = next
    i18n.global.locale.value = next
    document.documentElement.setAttribute('lang', next)
  }

  const setLocale = (value: string): void => {
    const next = normalizeLocale(value)
    if (next === locale.value) return
    applyLocale(next)
    localStorage.setItem(STORAGE_KEY, next)
  }

  // No stored preference resolves to English rather than the browser language:
  // an unconfigured account should look the same to everyone who opens it.
  const initializeLocale = (): void => {
    applyLocale(normalizeLocale(localStorage.getItem(STORAGE_KEY)))
  }

  return {
    locale,
    setLocale,
    initializeLocale
  }
})
